import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default function CalculatorForm() {
  $('#issuer_search').on('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    $('#portfolio_search').typeahead('val', '');
    $('#hidden_portfolio_id').val('');
  });

  $('#portfolio_search').on('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    $('#issuer_search').typeahead('val', '');
    $('#hidden_issuer_id').val('');
  });

  $('#impact-calculator-form').on('submit', function(ev) {
    let nameField = $('#client_calculator_name').val();
    let issuerId = $('#hidden_issuer_id').val();
    let portfolioId =  $('#hidden_portfolio_id').val();
    let sectionEnabled = $('.enabled-section-input:checked').length > 0;
    let benchmarkIssuerId = $('#hidden_benchmark_issuer_id').val()

    // Validate Name
    if (nameField.trim() === '') {
      ev.preventDefault();
      ToastCustom({title: 'Name Required', message: 'Please enter a name for the Impact Calculator.', delay: 3000, type: 'warning'});
      return;
    }

    // Validate either Issuer or Portfolio
    if (issuerId === '' && portfolioId === '') {
      ev.preventDefault();
      ToastCustom({title: 'Issuer/Portfolio Required', message: 'Please select either an Issuer or a Portfolio for the Impact Calculator.', delay: 3000, type: 'warning'});    
      return;  
    }

    // Validate Benchmark Issuer
    if (benchmarkIssuerId === '') {
      ev.preventDefault();
      ToastCustom({title: 'Benchmark Issuer Required', message: 'Please select a Benchmark Issuer for the Impact Calculator.', delay: 3000, type: 'warning'});
      return;
    }

    // Validate sections
    if (!sectionEnabled) {
      ev.preventDefault();
      ToastCustom({title: 'Section Required', message: 'Please select at least one section to include in the Impact Calculator.', delay: 3000, type: 'warning'});
      return;
    }
  });
}
